import React from 'react';
import PropTypes from 'prop-types';

const TileLink = ({ href, imageUrl, children }) => {
  const linkClass = `tile-link m-b-0 bg-black fade-overlay-new d-flex align-items-center justify-content-center border-radius-l like-h5 fw-medium link--white link--secondary text-center background-size-cover`;

  return (
    <a href={href} className={linkClass} style={{ backgroundImage: `url(${imageUrl})` }}>
      <span className="fade-overlay__inner">{children}</span>
    </a>
  );
};

TileLink.propTypes = {
  href: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  children: PropTypes.string,
};

export default TileLink;



// WEBPACK FOOTER //
// ./library/app/components/Global/Links/TileLink.js